/* kvedhic.js — v2 interactions: video click-to-play + FAQ accordion */
(function () {
  'use strict';

  function initVideos(root) {
    (root || document).querySelectorAll('[data-kv-video]').forEach(function (wrap) {
      if (wrap.dataset.kvInit) return;
      wrap.dataset.kvInit = '1';
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('.kv2-bf__play');
      if (!video || !btn) return;
      btn.addEventListener('click', function () {
        video.setAttribute('controls', '');
        video.play();
        wrap.classList.add('is-playing');
      });
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.kv2-faq__item').forEach(function (item) {
      if (item.dataset.kvInit) return;
      item.dataset.kvInit = '1';
      var q = item.querySelector('.kv2-faq__q');
      var a = item.querySelector('.kv2-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        if (open) {
          a.style.maxHeight = null;
          item.classList.remove('is-open');
        } else {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  function initAll(root) { initVideos(root); initFaq(root); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  // Re-init in Shopify theme editor when sections load/reload
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})();

/* ── Product page (PDP) interactions ── */
(function () {
  'use strict';

  function initPDP(root) {
    var scope = root || document;

    // Swipeable gallery slider
    scope.querySelectorAll('[data-kv-gallery]').forEach(function (gallery) {
      if (gallery.dataset.kvInit) return;
      gallery.dataset.kvInit = '1';
      var track = gallery.querySelector('.kv2-pdp__track');
      if (!track) return;
      var slides = gallery.querySelectorAll('.kv2-pdp__slide');
      var thumbs = gallery.querySelectorAll('.kv2-pdp__thumb');
      var dotsWrap = gallery.querySelector('[data-kv-dots]');
      var prev = gallery.querySelector('[data-kv-prev]');
      var next = gallery.querySelector('[data-kv-next]');
      var index = 0;
      var count = slides.length;

      // Build dots
      var dots = [];
      if (dotsWrap) {
        for (var i = 0; i < count; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'kv2-pdp__dot' + (i === 0 ? ' is-active' : '');
          (function (idx) { d.addEventListener('click', function () { go(idx); }); })(i);
          dotsWrap.appendChild(d);
          dots.push(d);
        }
      }

      function go(i) {
        index = Math.max(0, Math.min(count - 1, i));
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
        dots.forEach(function (dt, di) { dt.classList.toggle('is-active', di === index); });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.dataset.kvThumb, 10)); });
      });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      // Touch / drag swipe
      var startX = 0, deltaX = 0, dragging = false;
      function down(x) { dragging = true; startX = x; deltaX = 0; track.style.transition = 'none'; }
      function move(x) {
        if (!dragging) return;
        deltaX = x - startX;
        track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + deltaX + 'px))';
      }
      function up() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        var threshold = track.offsetWidth * 0.18;
        if (deltaX < -threshold) go(index + 1);
        else if (deltaX > threshold) go(index - 1);
        else go(index);
      }
      track.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
      track.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      track.addEventListener('touchend', up);
      track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', up);

      go(0);
    });

    // Variant radios -> update hidden select (so correct variant id submits)
    scope.querySelectorAll('.kv2-pdp__form').forEach(function (form) {
      if (form.dataset.kvInit) return;
      form.dataset.kvInit = '1';
      var select = form.querySelector('.kv2-pdp__variant-select');
      var radios = form.querySelectorAll('input[type="radio"]');
      function syncVariant() {
        var chosen = [];
        var groups = {};
        radios.forEach(function (r) { groups[r.name] = groups[r.name] || []; groups[r.name].push(r); });
        Object.keys(groups).forEach(function (name) {
          groups[name].forEach(function (r) { if (r.checked) chosen.push(r.value); });
        });
        if (!select) return;
        Array.prototype.forEach.call(select.options, function (opt) {
          var title = opt.textContent.split(' - ')[0].trim();
          if (title === chosen.join(' / ')) select.value = opt.value;
        });
      }
      radios.forEach(function (r) { r.addEventListener('change', syncVariant); });

      // Quantity steppers
      var qtyInput = form.querySelector('.kv2-pdp__qty-input');
      form.querySelectorAll('.kv2-pdp__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          v = btn.dataset.qty === 'plus' ? v + 1 : Math.max(1, v - 1);
          qtyInput.value = v;
        });
      });
    });

    // Sticky bar ATC -> trigger the real form submit
    scope.querySelectorAll('[data-kv-sticky-atc]').forEach(function (btn) {
      if (btn.dataset.kvInit) return;
      btn.dataset.kvInit = '1';
      btn.addEventListener('click', function () {
        var form = document.querySelector('.kv2-pdp__form');
        if (form) form.querySelector('[name="add"]').click();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initPDP(document); });
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initPDP(e.target); });
  }
})();